"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledClearInputButton = exports.LocationText = exports.LocationTextWrapper = exports.InputZipWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const helpers_1 = require("../helpers");
const inputDefaultStyles = `
  font-size: 16px;
  padding-left: 36px;
  font-family: 'vw-text',Helvetica,Arial,sans-serif;
  border-color: #dfe4e8;
  height: 36px;

  @media (min-width: ${helpers_1.Breakpoints.b560}px) {
    padding: 6px 0px 5px 35px;
    margin: 0;
  }
`;
const errorMessageDefaultStyles = `
  padding: 2px 8px;
  border-radius: 4px;
  background-color: #e4002c;
  color: #fff;
  font-family: 'vw-text',Helvetica,Arial,sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #ffffff;

  @media (min-width: ${helpers_1.Breakpoints.b560}px) {
    margin: 4px 0 4px 0;
    position: absolute;
    top: auto;
    right: auto;
  }
`;
const iconDefaultStyles = `
  left: 0;
  width: max-content;
`;
exports.InputZipWrapper = components_core_1.styled.div `
  ${({ isDefault, inputStyles, iconStyles }) => !isDefault
    ? `
        position: relative;
        border: 0;
        background: transparent;
        width: 100%;
        height: max-content;

        &.hide:not(.is-landscape){
          display: none;
        }

        .focus__container {
          .input-field-icon-button {
            ${iconStyles ? iconStyles : iconDefaultStyles}
          }

          .input-field-error {
            ${errorMessageDefaultStyles}
          }

          .input-text-field {
            ${inputStyles ? inputStyles : inputDefaultStyles}
          }

          &.has-error {
            .input-text-field {
              border-color: #e4002c;
            }
          }

          &.is-absolute {
            .input-field-error {
              ${errorMessageDefaultStyles}
              position: absolute;
              top: 10px;
              right: 0;
              height: 20px;
              margin: auto;
            }
          }
        }
        `
    : `
          padding-bottom: 37px;

          &.hide:not(.is-landscape) {
            display: none;
          }
          .location-text {
            display: none;
          }
          .focus__container {
            .input-field-error {
              ${errorMessageDefaultStyles}
            }

            .input-text-field {
              height: max-content;
              padding: 0 0 7px 0;
              font-size: 32px;
              font-weight: 200;
              font-stretch: normal;
              font-style: normal;
              letter-spacing: normal;
              color: #000000;
              border-bottom: solid 1px #001e50;

              &::placeholder {
                font-size: 18px;
              }
            }

            &.has-error {
              .input-text-field {
                border-color: #e4002c;
              }
            }
          }
        `}
`;
exports.LocationTextWrapper = components_core_1.styled.div `
  position: absolute;
  top: 0;
  right: 0;
  top: 50%;
  transform: translate(0%, -50%);
  margin: auto;
  height: max-content;
`;
const LocationTextDefaultStyles = `
  padding: 0;
  color: #001e50;
  outline: 0;
  font-size: 16px;
  line-height: normal;
  font-family: 'vw-head',Helvetica,Arial,sans-serif;
  font-weight: 300;

  display: inline-block;
  vertical-align: middle;
  height: auto;
`;
exports.LocationText = components_core_1.styled.div `
  ${LocationTextDefaultStyles}
`;
exports.StyledClearInputButton = components_core_1.styled.div `
  display: none;
  @media (min-width: ${helpers_1.Breakpoints.b960}px) {
    width: 17px;
    height: 17px;
    background: #e3e3e3;
    border-radius: 12.3636px;
    color: #001e50;
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    margin: 10px;
    cursor: pointer;
  }
`;
